import { Utils } from "@/plugins/utils";
import { runtimeConfig } from '@/config/runtimeConfig'
export default {
	namespaced: true,
	state: {

	},
	getters: {
		
	},
	mutations: {
		
	},
	actions: {
		async printCheque(store, {cv8, cf1cliente, cf1nome, vd1pedido}){
			
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Processando cheque...<br/>Insira a folha na impressora", indeterminate: true }, {root: true})
			let pd9 = await this._vm.$axios.post("/Printing/Cheque/Print", {
				cv8,
				cf1cliente,
				cf1nome,
				vd1pedido
			})
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				if(!!payload.relatPath)
					store.dispatch("openRelatsPath", [ payload.relatPath ])

				return payload.pd9model
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return pd9
		},
		openRelatsPath(store, relatsPath){
			for (const relatPath of relatsPath) {
				if(relatPath != null && relatPath != ""){
					let url = runtimeConfig.apiUri + relatPath + "?authorization=" + localStorage.getItem("token")
					window.open(url)
				}
			}
		},
		openLocalRelatsPath(store, relatsPath){
			for (const relatPath of relatsPath) {
				if(relatPath != null && relatPath != ""){
					let url = relatPath + "?authorization=" + localStorage.getItem("token")
					window.open(url)
				}
			}
		},
		async downloadFile(store, relatsPath){
			for (const relatPath of relatsPath) {
				let filename = relatPath
				filename = filename.substr(filename.lastIndexOf('/') + 1);
				let url = runtimeConfig.apiUri + relatPath + "?authorization=" + localStorage.getItem("token")
				var link=document.createElement('a');
				link.type="application/octet-stream"
				link.href = url;
				link.download = filename
				
				let blob = await fetch(url).then(r => r.blob());

				let reader = new FileReader();
				reader.readAsDataURL(blob); // converts the blob to base64 and calls onload

				reader.onload = function() {
					link.href = reader.result; // data url
					link.click();
				};
			}
		},
		async exportedFile(store, path){
			let filename = path
			filename = filename.substr(filename.lastIndexOf('/') + 1);
			let url = runtimeConfig.apiUri + "/Printing/Print/ExportedFile" + `?pathFile=${path}&authorization=${localStorage.getItem("token")}`
			var link=document.createElement('a');
			link.type="application/octet-stream"
			link.href = url;
			link.download = filename
			
			let blob = await fetch(url).then(r => r.blob());

			let reader = new FileReader();
			reader.readAsDataURL(blob); // converts the blob to base64 and calls onload

			reader.onload = function() {
				link.href = reader.result; // data url
				link.click();
			};
		}
	}
}